import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner'
import { cx } from '@/utils/cx'

interface ButtonLabelProps {
  label?: string
  /** the button's request is in flight: a spinner takes the place of the text */
  isLoading: boolean
}

/** the content of a `Button` that shows a spinner while the action it started runs */
export const ButtonLabel = ({ label, isLoading }: ButtonLabelProps) => (
  <>
    {isLoading && <LoadingSpinner inButton />}
    <span className={cx('generic__button-text', isLoading && 'generic__button-text--loading')}>
      {label}
    </span>
  </>
)
